/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
/* eslint-disable ember/no-runloop */
import { assert } from "@ember/debug";
import { action } from "@ember/object";
import { later } from "@ember/runloop";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";

interface Args {
  changeset: EmberChangeset;
  defaultChatMessage: string;
  willSendMessage: boolean;
}

export default class ChatSendMessageForcComponent extends Component<Args> {
  static chatMessageKey = "chatMessage";
  static willSendMessageKey = "willSendMessage";

  chatMessageKey = ChatSendMessageForcComponent.chatMessageKey;
  willSendMessageKey = ChatSendMessageForcComponent.willSendMessageKey;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this.setupDefaultValues();
  }

  @action
  setupDefaultValues() {
    assert(
      "A '@changeset' should be provided to the 'ChatSendMessageForcComponent'. It is in this changeset that the message will be written and then you could use the 'save-send-message' utils to save the message from the given changeset.",
      Boolean(this.args.changeset)
    );

    later(
      this,
      function () {
        this.args.changeset.set(
          this.chatMessageKey,
          this.args.defaultChatMessage
        );
        this.args.changeset.set(
          this.willSendMessageKey,
          this.args.willSendMessage
        );
      },
      500
    );
  }
}
